import React from "react";
import { Link, useHistory } from "react-router-dom";
import { PageSettings } from "./../config/page-settings.js";
import { Api } from "./../app-controller.js";
import { makeStyles } from "@material-ui/core/styles";
import Select from "react-select";
import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";


const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#656565",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class RegisterV3 extends React.Component {
  static contextType = PageSettings;

  state = {
    name: "",
    apellido_materno: "",
    apellido_paterno: "",
    email: "",
    telefono: "",
    password: "",
    password_confirmation: "",
    sexo: "",
    options: Api.loadCatalogue("locations"),
    options_access: Api.loadCatalogue("accesos"),
    options_sexo: Api.loadCatalogue("cat_sexo"),
    access: [],
    departamento_id: "",
    municipio_id: "",
    group: 1,
    email_error: "",
    password_error: "",
    name_error: "",
    first_last_name_error: "",
    second_last_name_error: "",
    errors: [],
  };

  ITEM_HEIGHT = 48;
  ITEM_PADDING_TOP = 8;
  MenuProps = {
    PaperProps: {
      style: {
        maxHeight: this.ITEM_HEIGHT * 4.5 + this.ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300,
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
  }));

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDepartamentos = this.handleDepartamentos.bind(this);
    this.handleSexo = this.handleSexo.bind(this);
    this.handleMunicipios = this.handleMunicipios.bind(this);
    this.handleChangeMultiple = this.handleChangeMultiple.bind(this);
    this.maxLengthCheck = this.maxLengthCheck.bind(this);
    this.handleTelefono = this.handleTelefono.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("sesion");
    localStorage.removeItem("user");
    localStorage.removeItem("grupos");
    localStorage.removeItem("nivel_actual");
    localStorage.removeItem("nivel_name");
    localStorage.removeItem("accesos");
    localStorage.removeItem("token");

    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetBodyWhiteBg(false);
  }

  handleDepartamentos(e) {
    this.setState({ departamento_id: e.target.value });
  }

  handleSexo(e) {
    this.setState({ sexo: e.target.value });
  }

  handleMunicipios(e) {
    this.setState({ municipio_id: e.target.value }, () => {});
  }

  handleChangeMultiple = (e) => {
    // this.setState({ access: e.target.value });
    this.setState({ access: e });
  };

  handleSubmit(event) {
    event.preventDefault();

    Api.fetch("public/register", this.state, "POST").then((data) =>
      this.handleRegister(data)
    );
  }

  handleTelefono(evt) {
    let regex = /^[0-9]{1,8}$/;
    if (evt.target.value === "" || regex.test(evt.target.value)) {
      this.setState({ telefono: evt.target.value });
    }
  }

  handleRegister(Response) {
    if (Response.errors) {
      let tplErrors = [];
      let errorMessage = "";
      for (let error in Response.errors) {
        errorMessage = Response.errors[error].toString();

        let errox = errorMessage.split(",");

        for (let erro in errox) {
          errorMessage = errox[erro].toString();
          errorMessage = errorMessage.replace("password", "contraseña");
          errorMessage = errorMessage.replace("email", "correo electrónico");
          errorMessage = errorMessage.replace("id", "");
          tplErrors.push(errorMessage);
        }
      }
      this.setState({ errors: tplErrors });
      return false;
    }
    //checar response errors

    if (Response.user) {
      localStorage.sesion = JSON.stringify(Response.user);
      Swal.fire({
        title: Response.message,
        icon: "success",
        text: "Se ha enviado un correo de confirmación",
        timer: 3000,
      }).then(()=>{
          window.location="/confirm"; // envía a ventana donde pide confirmar el correo enviado
      });
    }
  }

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  render() {
    return (
      <div className="register register-with-news-feed">
        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: "url('../assets/pulpa_pellets_cabecera.jpg')",
            }}
          ></div>
          <div className="news-caption">
            <h4 className="caption-title">
              Sistema Integral Nacional de Insumos Pecuarios
            </h4>
            <p></p>
          </div>
        </div>
        <div className="right-content">
          <h1 className="register-header">Registro</h1>
          <div className="register-content">
            <form
              className="margin-bottom-0"
              id="frmRegister"
              onSubmit={this.handleSubmit}
            >
              <label className="control-label">
                Nombre <span className="text-danger">*</span>
              </label>
              <div className="row row-space-10">
                <div className="col-md-12 m-b-15">
                  <input
                    type="text"
                    name="name"
                    value={this.state.name}
                    onChange={(e) =>
                      this.setState({ name: e.target.value.toUpperCase() })
                    }
                    className="form-control"
                    placeholder="Nombre(s)"
                    maxLength="120"
                    required
                  />
                </div>
              </div>
              <div className="row row-space-10">
                <div className="col-md-6 m-b-15">
                  <input
                    type="text"
                    name="apellido_paterno"
                    value={this.state.apellido_paterno}
                    onChange={(e) =>
                      this.setState({
                        apellido_paterno: e.target.value.toUpperCase(),
                      })
                    }
                    className="form-control"
                    placeholder="Apellido paterno"
                    maxLength="60"
                    required
                  />
                </div>
                <div className="col-md-6 m-b-15">
                  <input
                    type="text"
                    name="apellido_materno"
                    value={this.state.apellido_materno}
                    onChange={(e) =>
                      this.setState({
                        apellido_materno: e.target.value.toUpperCase(),
                      })
                    }
                    className="form-control"
                    placeholder="Apellido materno"
                    maxLength="60"
                    //required
                  />
                </div>
              </div>
              {/*<div className="row row-space-10">
                <div className="col-md-6 m-b-15">
                  <input
                    type="radio"
                    checked={this.state.sexo === "M"}
                    onChange={(e) => this.setState({ sexo: "M" })}
                  /> 	&nbsp; Masculino
                </div>
                <div className="col-md-6 m-b-15">
                  <input
                    type="radio"
                    checked={this.state.sexo === "F"}
                    onChange={(e) => this.setState({ sexo: "F" })}
                  />	&nbsp; Femenino
                </div>
                  </div>*/}

              <div className="row row-space-10">
                <div className="col-md-12 m-b-15">
                  <label className="control-label">
                    Sexo<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={this.handleSexo}
                    name="sexo"
                    className="form-control"
                    value={this.state.sexo}
                  >
                    <option className="dropdown-item" value="">
                      Seleccione...
                    </option>
                    {this.state.options_sexo.map((option) => (
                      <option
                        className="dropdown-item"
                        key={option.id}
                        value={option.id}
                      >
                        {option.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row row-space-10">
                <div className="col-md-12 m-b-15">
                  <label className="control-label">
                    Departamento<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={this.handleDepartamentos}
                    name="departamento_id"
                    className="form-control"
                    value={this.state.departamento_id}
                  >
                    <option className="dropdown-item" value="">
                      Seleccione...
                    </option>
                    {this.state.options.departamentos.map((option) => (
                      <option
                        className="dropdown-item"
                        key={option.id}
                        value={option.id}
                      >
                        {option.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row row-space-10">
                <div className="col-md-12 m-b-15">
                  <label className="control-label">
                    Municipio<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={this.handleMunicipios}
                    name="municipio_id"
                    className="form-control"
                  >
                    <option className="dropdown-item" value="">
                      Seleccione...
                    </option>
                    {this.state.options.municipios
                      .filter((e) => e.estado_id === this.state.departamento_id)
                      .map((option) => (
                        <option
                          className="dropdown-item"
                          key={option.id}
                          value={option.id}
                        >
                          {option.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <label className="control-label">
                Teléfono <span className="text-danger">*</span>
              </label>
              <div className="row m-b-15">
                <div className="col-md-12">
                  <input
                    type="text"
                    name="telefono"
                    value={this.state.telefono}
                    onChange={this.handleTelefono}
                    className="form-control"
                    placeholder="Teléfono"
                    // pattern="[0-9]{4}[0-9]{4}"
                    // maxLength="8"
                    // onInput={this.maxLengthCheck}
                    required
                  />
                </div>
              </div>

              <label className="control-label">
                Correo electrónico <span className="text-danger">*</span>
              </label>
              <div className="row row-space-10">
                <div className="col-md-12 m-b-15">
                  <input
                    type="text"
                    name="email"
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value })}
                    className="form-control"
                    placeholder="Correo electrónico"
                    maxLength="255"
                    required
                  />
                </div>
              </div>
              <label className="control-label">
                Contraseña <span className="text-danger">*</span>
              </label>
              <div className="row row-space-10">
                <div className="col-md-12 m-b-15">
                  <input
                    type="password"
                    name="password"
                    value={this.state.password}
                    onChange={(e) =>
                      this.setState({ password: e.target.value })
                    }
                    className="form-control"
                    placeholder="Contraseña"
                    maxLength="255"
                    required
                  />
                </div>
              </div>

              <label className="control-label">
                Confirmar contraseña <span className="text-danger">*</span>
              </label>
              <div className="row row-space-10">
                <div className="col-md-12 m-b-15">
                  <input
                    type="password"
                    name="password_confirmation"
                    value={this.state.password_confirmation}
                    onChange={(e) =>
                      this.setState({ password_confirmation: e.target.value })
                    }
                    className="form-control"
                    placeholder="Contraseña"
                    maxLength="255"
                    required
                  />
                </div>
              </div>

              <div className="row row-space-10">
                <div className="col-md-12 m-b-15">
                  <label className="control-label">
                    Funciones<span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti
                    styles={colourStyles}
                    placeholder="Seleccione"
                    onChange={this.handleChangeMultiple}
                    theme="neutral40"
                    options={this.state.options_access}
                    getOptionLabel={(option) => option.descripcion}
                    getOptionValue={(option) => option.id}
                    noOptionsMessage={() =>
                      "No se encontraron más tipos de funciones"
                    }
                  />
                  {/* <Select
                    style={{ background: "aliceblue", borderRadius: "5px" }}
                    multiple
                    value={this.state.access}
                    onChange={this.handleChangeMultiple}
                    renderValue={(selected) => (
                      <div className={this.useStyles.chips}>
                        {selected.map((value) => {
                          for (
                            let index = 0;
                            index < this.state.options_access.length;
                            index++
                          ) {
                            if (this.state.options_access[index].id === value) {
                              this.name = this.state.options_access[
                                index
                              ].descripcion;
                            }
                          }
                          return (
                            <Chip
                              key={value}
                              label={this.name}
                              className={this.useStyles.chip}
                            />
                          );
                        })}
                      </div>
                    )}
                    MenuProps={this.MenuProps}
                  >
                    {this.state.options_access.map((option) => (
                      <MenuItem
                        key={option.id}
                        value={option.id}
                        className={this.useStyles.chip}
                      >
                        {option.descripcion}
                      </MenuItem>
                    ))}
                  </Select> */}
                </div>
              </div>

              <div className="form-group m-b-15">
                <span style={{ color: "red" }}>
                  {this.state.errors.map((error) => (
                    <li key={error}>{error}</li>
                  ))}
                </span>
              </div>

              <div className="register-buttons">
                <button
                  type="submit"
                  className="btn btn-primary btn-block btn-lg"
                >
                  Regístrate
                </button>
              </div>
              <div className="m-t-20 p-b-20 ">
                ¿Ya tienes una cuenta? <Link to="/login">Iniciar sesión</Link>.
              </div>
              <hr></hr>
              <p className="text-center">
                By <b>ASEENTI</b>
              </p>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

//export default withRouter(RegisterV3);

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <RegisterV3 auth={auth} history={history} {...props} />;
};
